import cx from 'classnames';

import {sprinkles} from '#style/sprinkles';

import {HeroProps} from './Hero.types';

import * as css from './Hero.css';

/**
 * This component is used for rendering a full-width page header with a distinct
 * background color and curved bottom edge.
 *
 * It is intended to be used at the top of a page, and therefore the background
 * color will extend beyond the top edge of the component's bounding box to
 * account for the space occupied by the main navigation header. If no header is
 * rendered on a page, this extra space will safely be clipped by the top-edge
 * of the document.
 *
 * Depending on the prop configuration, this component may create it's own
 * padding/margin values for the bottom edge of the component. This is to allow
 * for consistent handling of overlapping content, either within the `Hero`
 * itself (ie, its' scroll indicator), or the content that follows the `Hero`.
 *
 * It is used by most pages throughout the app.
 */
export const Hero = ({
  children,
  className,
  showOverlap = true,
  showScrollIndicator = false,
  variant = 'dark',
  ...otherProps
}: HeroProps) => (
  <div
    className={cx(css.root({showOverlap, showScrollIndicator, variant}), className)}
    {...otherProps}>
    <div className={css.bg({variant})} />

    <div className={sprinkles({pos: 'relative'})}>{children}</div>

    {showScrollIndicator && <div className={css.indicator} />}
  </div>
);
